var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchaseInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.5 5.23828H20.6992V2.3584C20.6992 2.1038 20.6149 1.85963 20.4649 1.6796C20.3149 1.49958 20.1114 1.39844 19.8993 1.39844H2.29997C2.0878 1.39844 1.88433 1.49958 1.73431 1.6796C1.58428 1.85963 1.5 2.1038 1.5 2.3584V5.23828Z",
    fill: "#BEC9D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8993 1.39844H2.29997C1.85816 1.39844 1.5 1.82823 1.5 2.3584V19.6377C1.5 20.1679 1.85816 20.5977 2.29997 20.5977H19.8993C20.3411 20.5977 20.6992 20.1679 20.6992 19.6377V2.3584C20.6992 1.82823 20.3411 1.39844 19.8993 1.39844Z",
    stroke: "#C0C0C6",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.23828H20.6992",
    stroke: "#C0C0C6",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 9.07812C15.0993 10.3511 14.6779 11.572 13.9278 12.4721C13.1776 13.3722 12.1603 13.8779 11.0994 13.8779C10.0386 13.8779 9.02125 13.3722 8.27113 12.4721C7.52102 11.572 7.09961 10.3511 7.09961 9.07812",
    stroke: "#C0C0C6",
    strokeWidth: 1.88228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseInActive);
export default __webpack_public_path__ + "static/media/PurchaseInActive.3da86046ec23bfbeeacc87994e7862cb.svg";
export { ForwardRef as ReactComponent };